import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function ProtectedRoute({ children, requirePasswordChange = true }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-black text-[#22ff77] font-display tracking-widest text-sm">
        Učitavanje...
      </div>
    );
  }
  if (!user) return <Navigate to="/prijava" replace />;

  // Force first-login password change for accounts whose must_change_password flag
  // is still set (e.g. admin after deployment / ADMIN_EMAIL migration).
  if (
    requirePasswordChange &&
    user.must_change_password &&
    location.pathname !== "/promena-lozinke-obavezna"
  ) {
    return <Navigate to="/promena-lozinke-obavezna" replace />;
  }

  return children;
}
